// Module
var code = "<mn-number-container type=\"float\" empty=\"true\" disabled></mn-number-container>";
// Exports
module.exports = code;